import React from "react";
import certi1 from "../../assets/certificates/udemy-react.pdf";
import certi2 from "../../assets/certificates/udemy-react.pdf";
import certi3 from "../../assets/certificates/ielts-trf.pdf";
import certi4 from "../../assets/certificates/coursera-fusion 360.pdf";
import certi5 from "../../assets/certificates/mu-german-certificate.pdf";

const Services = (props) => {
  return (
    <section id="services" className="services">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Certifications</h2>
          <p>Below is a quick overview of my certifications</p>
        </div>
        <div className="row">
          <div className="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay={100}>
            <div className="icon-box iconbox-grey">
              <div className="icon">
                <i className='bx bx-news' ></i>
              </div>
              <h4><a target="_blank" rel="noreferrer" href={certi1}>Full Stack MERN Course with React, NodeJS, MongoDB, Express</a></h4>
              <p>Udemy, 2021</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-md-0" data-aos="zoom-in" data-aos-delay={200}>
            <div className="icon-box iconbox-grey ">
              <div className="icon">
                <i className='bx bx-news'></i>
              </div>
              <h4><a target="_blank" rel="noreferrer" href={certi2}>The Complete ReactJs Course - Basics to Advanced (2021)</a></h4>
              <p>Udemy, 2021</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-lg-0" data-aos="zoom-in" data-aos-delay={300}>
            <div className="icon-box iconbox-grey">
              <div className="icon">
                <i className="bx bx-news" />
              </div>
              <h4><a target="_blank" rel="noreferrer" href={certi3}>International English Language Testing System (IELTS)</a></h4>
              <p>British Council</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4" data-aos="zoom-in" data-aos-delay={100}>
            <div className="icon-box iconbox-grey">
              <div className="icon">
                <i className="bx bx-news" />
              </div>
              <h4><a target="_blank" rel="noreferrer" href={certi4}>Digital Manufacturing with Autodesk Fusion 360</a></h4>
              <p>Autodesk, 2018</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4" data-aos="zoom-in" data-aos-delay={200}>
            <div className="icon-box iconbox-grey">
              <div className="icon">
                <i className="bx bx-news" />
              </div>
              <h4><a target="_blank" rel="noreferrer" href={certi5}>Certificate course in German</a></h4>
              <p>Mumbai University, 2015</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}

export default Services;